// saloni-ootd-cart-guard
// Removes cart line items tagged properties._ootd === "true" whenever the cart no
// longer meets the same eligibility gate that controls the OOTD widget's visibility
// (see snippets/custom-cart-recommendations.liquid / #ootd-eligibility-marker).
// Gated by the "Remove OOTD products from cart when no longer eligible" customizer
// setting (section.settings.remove_ootd_on_ineligible, mini-cart.liquid schema),
// exposed here via #mini-cart's data-ootd-auto-remove attribute - when off, this
// script leaves ineligible OOTD items in the cart untouched (legacy hide-only behavior).
// Self-contained: does not modify theme.js/vendor.js, only listens to the DOM.
(function () {
  'use strict';

  var OOTD_GUARD_DEBUG = false;
  var MUTATION_DEBOUNCE_MS = 100;
  var NOTIFICATION_MESSAGE = 'An item was removed because your cart no longer qualifies for this offer.';

  var isOotdCheckInFlight = false;
  var skipNextMutationCheck = false;
  var mutationDebounceTimer = null;

  function log() {
    if (OOTD_GUARD_DEBUG && window.console) {
      console.log.apply(console, ['[OOTD GUARD]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  function postCartForm(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: new URLSearchParams(data).toString()
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      }
      return response.json().catch(function () {
        return {};
      }).then(function (errorPayload) {
        return Promise.reject(errorPayload);
      });
    });
  }

  function removeLineItems(lineKeysArr) {
    if (!lineKeysArr.length) {
      return Promise.resolve();
    }
    var updates = {};
    lineKeysArr.forEach(function (lineKey) {
      updates['updates[' + lineKey + ']'] = 0;
    });
    log('Removing line keys:', lineKeysArr);
    return postCartForm('/cart/update.js', updates);
  }

  function isEligible() {
    var marker = document.getElementById('ootd-eligibility-marker');
    if (!marker) {
      // Marker absent means the OOTD widget isn't rendering at all right now
      // (e.g. merchant disabled it in the customizer). Treat as ineligible so a
      // stray _ootd item doesn't keep sitting in the cart with no active offer
      // behind it.
      return false;
    }
    return marker.getAttribute('data-ootd-eligible') === 'true';
  }

  function isAutoRemoveEnabled() {
    var cartDrawer = document.getElementById('mini-cart');
    // Default to enabled (matches the schema's own default) if the attribute is
    // ever missing, rather than silently doing nothing.
    return !cartDrawer || cartDrawer.getAttribute('data-ootd-auto-remove') !== 'false';
  }

  function notifyRemoval() {
    document.dispatchEvent(new CustomEvent('cart-notification:show', {
      detail: { status: 'error', error: NOTIFICATION_MESSAGE }
    }));
  }

  function refreshCartDrawer() {
    skipNextMutationCheck = true;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
  }

  function checkAndRemoveIfIneligible() {
    if (isOotdCheckInFlight || isEligible() || !isAutoRemoveEnabled()) {
      return;
    }

    isOotdCheckInFlight = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var keysToRemove = (cart.items || [])
          .filter(function (item) {
            return item.properties && item.properties._ootd === 'true';
          })
          .map(function (item) {
            return item.key;
          });

        if (!keysToRemove.length) {
          isOotdCheckInFlight = false;
          return;
        }

        return removeLineItems(keysToRemove).then(function () {
          isOotdCheckInFlight = false;
          notifyRemoval();
          refreshCartDrawer();
        });
      })
      .catch(function (error) {
        isOotdCheckInFlight = false;
        log('Error during eligibility check/removal:', error);
      });
  }

  function scheduleCheck() {
    if (skipNextMutationCheck) {
      skipNextMutationCheck = false;
      return;
    }
    if (mutationDebounceTimer) {
      clearTimeout(mutationDebounceTimer);
    }
    mutationDebounceTimer = setTimeout(checkAndRemoveIfIneligible, MUTATION_DEBOUNCE_MS);
  }

  function init() {
    var cartDrawer = document.getElementById('mini-cart');
    if (cartDrawer && window.MutationObserver) {
      var observer = new MutationObserver(scheduleCheck);
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    // Catch a cart that's already ineligible when the page itself first loads
    // (e.g. shopper left and came back later with a changed cart).
    checkAndRemoveIfIneligible();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
